// ─────────────────────────────────────────────────────────────
// DEPRECATED: Use SEGMENTS and PATHS from '@/app/router/routes' instead.
// This file only re-exports for backwards compatibility during migration.
// ─────────────────────────────────────────────────────────────

export type { RouteAction } from './routes'
export { ROUTE_ACTIONS, ROUTE_LABELS, SEGMENTS } from './routes'

// Legacy aliases — prefer importing from '@/app/router/routes' directly
export const PRIVATE_ROUTE = {
  ADMIN: 'admin',
  UNAUTHORIZED: 'unauthorized'
} as const

export const PUBLIC_ROUTE = {
  AUTH: 'auth',
  UNAUTHORIZED: 'unauthorized'
} as const

export const ROUTES_ACTIONS = {
  ID: 'id',
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
  VALIDATE: 'validate'
} as const

export const ROUTES_NAME: Record<string, string> = {
  admin: 'Inicio',
  business: 'Datos de la empresa',
  clients: 'Clientes',
  negotiations: 'Negociaciones',
  deliveries: 'Postventa',
  config: 'Configuración'
}
